<template>
<el-form @submit.native.prevent>
  <el-input
  placeholder="搜索信息"
  v-model="search"
  @keypress.enter.native="a"
  >
    <el-button slot="append" icon="el-icon-search" @click="a" v-model="search"></el-button>
  </el-input>
</el-form>
</template>

<script>
export default {
  name: 'search',
  data () {
    return {
      search: this.search
    }
  },
  methods: {
    a () {
      if (!this.search) {
        this.$message({
          showClose: true,
          message: '请输入您要搜索的内容',
          type: 'warning'
        })
      } else {
        this.$emit('reset', 0)
        /* eslint-disable */
        this.$router.replace({path: '/search', query: {q: this.search}}).catch(err => {
        })
        this.search = ''
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/widget/search.vue